import { ReactComponent as MobileLogo } from "../../assets/images/logo/img-logo-white_no_icon.svg"
import { ReactComponent as SideBarBtn } from "../../assets/images/icons/ic-mobile-sidebar.svg"
import { useTranslation } from "react-i18next";
import { UserAvatarButton } from "./UserAvatarButton"
const TopBar = ({ topBarClick, topBarMobileClick }) => {

    const { t } = useTranslation();

    return (
        <>
            {/* 桌機版 topbar */}
            <div className='layout-desktop-topbar hidden lg:flex'>
                <button onClick={topBarClick} className="desktop-menu-btn active"></button>
                <UserAvatarButton type="topBar" />
            </div>
            {/* 手機版 topbar */}
            <div className='layout-mobile-topbar lg:hidden'>
                <button onClick={topBarMobileClick} className="mobile-menu-btn active">
                    <SideBarBtn />
                </button>
                <MobileLogo className='img-mobile-logo' />
            </div>
        </>
    )
}

export default TopBar;